export const dateMask = [
  /[0-1]/,
  /\d/,
  '/',
  /[0-3]/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const timeMask = ['\u2000', /[0-1]/, /\d/, ':', /[0-5]/, /\d/];
export const secondsMask = [':', /[0-5]/, /\d/];
export const meridiemMask = ['\u2000', /[aApP]/, /[mM]/];
export const dateRangeDivider = ['\u2000', '-', '\u2000'];
